<template>
  <div>
    <b-row>
      <b-col >
        <vs-button style="border-radius: 5px;" variant="primary" v-on:click="excelIndir()" size="sm">
          <download-excel
            v-if="!isMobile()"
            class="btn btn-default"
            :data="excelData"
            name="excelData.xls"
            style="
              text-align: center;
              padding: 0px;
              color: white;
            "
          >
            Excel
          </download-excel>
        </vs-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import { BButton } from "bootstrap-vue";
export default {
  props: ["excelData"],
  components: {
    BButton,
  },
  data() {
    return {
      isMobile: function () {
        return isMobile;
      },
      excelYadirData: [],
    };
  },
  methods: {
    excelIndir() {
      //   alert("in");
      var dataFormatExcel = [];
      var dataFormat = [];
      dataFormatExcel = this.excelData;

      dataFormatExcel.forEach((value, index) => {
        var priceParseList = value.price;
        var productPrice = priceParseList;

        dataFormat.push({
          "Stok Kodu": value.productCode,
          "Stok Adı": value.productName,
          Barcod: value.barcode,
          KDV: value.vat,
          Fiyat: productPrice,
          Miktar: value.quantity,
          Kategori: value.kategoriKodu,
          Açıklama: value.details,
        });
      });
      this.excelYadirData = dataFormat;
    },
  },
  created() {

  },
};
</script>